<template>
  <div class="wish-list-contents__container">
    <div class="wish-list-contents__empty-body">
      <div class="wish-list-contents__header">
        <div class="wish-list-contents__title-suffix subhead-bold">
          ほしいものリスト
        </div>
      </div>
      <div class="wish-list-contents__title body-bold">
        <span>ギフト詳細ページのハートアイコンをタップして</span>
        <span>ほしいものリストを登録してみましょう！</span>
      </div>
      <div class="wish-list-contents__image-area">
        <img
          src="../../../../../../images/wish-list-sample.svg"
          class="wish-list-contents__image"
        />
      </div>
      <div class="wish-list-contents__description">
        プロフィール画面には、今あなたがほしいと思っているギフトをリストとして登録・公開しておくことができます。各ギフトの詳細ページにあるハート型のアイコンを押すと、リスト内にギフトを追加することができます。
      </div>
      <div>
        <a
          href="https://guide.giftee.com/faq/277/"
          class="wish-list-contents__link-to-guide text-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          リストの詳しい編集方法を確認する
        </a>
      </div>
      <div>
        <a
          :href="itemsPath"
          class="wish-list-contents__link-to-items-index text-link"
        >
          ギフト一覧から登録するギフトを探す
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemsPath: {
      type: String,
      require: false,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.wish-list-contents {
  &__empty-body {
    margin: auto;
    text-align: center;
    padding: 0 16px;

    .wish-list-contents {
      &__header {
        max-width: $small-contents-width;
        margin: 0 auto;
        padding: 32px 0 16px 0;
        text-align: left;
        border-bottom: 1px solid $gray-2;
      }

      &__title {
        margin: 0 auto 24px;
        padding-top: 32px;
        display: block;

        span {
          display: block;
        }
      }

      &__image-area {
        margin: 24px 0;
      }

      &__image {
        max-width: 312px;
        width: 100%;
      }

      &__description {
        @extend %caption;
        text-align: left;
        max-width: $small-contents-width;
        margin: auto;
      }

      &__link-to-guide {
        margin-top: 24px;
        display: inline-block;
        font-size: 14px;
        line-height: 1.6;
      }

      &__link-to-items-index {
        margin: 16px auto 24px auto;
        display: inline-block;
        font-size: 14px;
        line-height: 1.6;
      }
    }
  }
}
</style>
